import { useMutation, useQueryClient } from "react-query";
import { submitOutboundComposite, submitOutboundResource } from "@/services/outbound";
/** Returns true when a submission payload is a composite (encounter + document). */
export function isCompositePayload(payload) {
  return "encounter" in payload || "doc" in payload;
}

/** Mutation hook that submits a single or composite outbound payload and refreshes encounters. */
export function useOutboundSubmit(workspaceId, patientId) {
  var queryClient = useQueryClient();
  return useMutation(function (payload) {
    return isCompositePayload(payload) ? submitOutboundComposite(workspaceId, String(patientId), payload) : submitOutboundResource(workspaceId, String(patientId), payload);
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries(["patient-encounters-infinite", workspaceId, patientId]);
      queryClient.invalidateQueries(["patient-encounters", workspaceId, patientId]);
      queryClient.invalidateQueries(["outbound-sync-status", workspaceId, patientId]);
    }
  });
}